// admin 配置
const ADMIN = {
  // palettes: ['#8A1106','#265bab', '#940701','#376493','#f5222d', '#fa541c', '#fadb14', '#3eaf7c', '#13c2c2', '#1890ff', '#722ed1', '#eb2f96'],
  palettes: ['#8A1106','#265bab', '#940701','#084b9d','#f10215','#ff7a61'],
  animates: require('./animate.config').preset,
  theme: {
    mode: {
      DARK: 'dark',
      LIGHT: 'light',
      LIGHTMENU: 'lightmenu',
      NIGHT: 'night'
    }
  },
  layout: {
    SIDE: 'side',
    HEAD: 'head'
  }
}

module.exports = ADMIN
